window.addEventListener('load', () => {
  const modal = document.getElementById('sizeGuideModal');
  const openBtn = document.getElementById('size-guide-trigger');
  const closeBtn = document.getElementById('closeSizeGuide');

  if (openBtn) {
    openBtn.addEventListener('click', () => {
      modal.showModal();
    });
  } else {
    console.log('openBtn not found');
  }

  closeBtn.addEventListener('click', () => {
    modal.close();
  });

  modal.addEventListener('click', (e) => {
    const rect = modal.getBoundingClientRect();
    if (
      e.clientX < rect.left ||
      e.clientX > rect.right ||
      e.clientY < rect.top ||
      e.clientY > rect.bottom
    ) {
      modal.close();
    }
  });
});
